import { SCol, SContainer, SRow } from '@avalara/skylab-sdk/react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

import { isEsbFormOneIncomplete } from '../../../lib/shared-signup';
import { initializeBigCommercePaidOffer } from '../../../lib/side-effects/esb';
import { selectState } from '../../../selectors';
import { setEsbPath } from '../../../store/esb';
import OrderSummary from '../../offer/order-summary';
import CompanyInfo from './company-info';
import TrialPaymentMethod from './trial-payment-method';

const EsbStartTrialForms = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const {
    esb: { esbPartner, esbPath },
    sharedSignup,
  } = useSelector(selectState);

  const isCompanyInfoComplete = sharedSignup.isPrepopulated || !isEsbFormOneIncomplete(sharedSignup);

  useEffect(() => {
    if (/big-commerce/.test(esbPartner || '')) dispatch(initializeBigCommercePaidOffer());
    else dispatch(setEsbPath('start'));
  }, [esbPartner]);

  if (!esbPartner) return null;

  return (
    <SContainer className='pad-top-xl'>
      <SRow>
        <SCol span='8' className='pad-left-none'>
          <Switch>
            <Route path={`/${esbPath}/:partnerId/company-info`} component={CompanyInfo} />

            {isCompanyInfoComplete && (
              <Route path={`/${esbPath}/:partnerId/payment-method`} component={TrialPaymentMethod} />
            )}

            <Redirect
              to={{
                pathname: `/${esbPath}/${esbPartner}/company-info`,
                search: window.location.search,
              }}
            />
          </Switch>
        </SCol>

        {pathname.endsWith('payment-method') && (
          <SCol span='4'>
            <OrderSummary />
          </SCol>
        )}
      </SRow>
    </SContainer>
  );
};

export default EsbStartTrialForms;
